import apihelper from "@/helpers/apihelper";
export default {
  async uploadEwc(context, { ewcfile }) {
    const token = context.rootGetters.token;
    const url = `${process.env.VUE_APP_ROOT_API}${process.env.VUE_APP_ROOT_API_ENV}/combinatieritten/importEwc`;

    const formData = new FormData();
    formData.append("ewcfile", ewcfile);

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const responseData = await response.json();
    if (!response.ok || !responseData.status) {
      const error = new Error(
        responseData.error_description || "Failed to import EWC file.",
      );
      throw error;
    }
    return responseData.status;
  },

  async getEwcRitten(context, payload){
    const token = context.rootGetters.token;
    const url = `${process.env.VUE_APP_ROOT_API}${process.env.VUE_APP_ROOT_API_ENV}/combinatieritten/listEwcRides`;

    const responseData = await apihelper.fetchPostRequest({
      url,
      token,
      payload: JSON.stringify(payload),
      errorMsg: "Failed to get EWC rides.",
    });
    context.commit("setRitten", responseData.data);
    context.commit(
      "setPages",
      Math.ceil(responseData.metadata.count / responseData.metadata.PageSize),
    );
  },

  async getEwcAddresses(context, {complete}){
    const token = context.rootGetters.token;
    const url = `${process.env.VUE_APP_ROOT_API}${process.env.VUE_APP_ROOT_API_ENV}/combinatieritten/listewclocations?complete=${complete}`;

    const responseData = await apihelper.fetchGetRequest({
      url,
      token,
      errorMsg: "Failed to get EWC addresses.",
    });
    return responseData.data;
  },

  async saveEwcAddress(context, payload){
    const token = context.rootGetters.token;
    const url = `${process.env.VUE_APP_ROOT_API}${process.env.VUE_APP_ROOT_API_ENV}/combinatieritten/saveEwcLocation`;
    const responseData = await apihelper.fetchPostRequest({
      url,
      token,
      payload: JSON.stringify(payload),
      errorMsg: "Failed to save EWC address.",
    });
    return responseData.status;
  },

  async syncEwc(context, payload) {
    const token = context.rootGetters.token;
    const url = `${process.env.VUE_APP_ROOT_API}${process.env.VUE_APP_ROOT_API_ENV}/combinatieritten/syncCrewManifest`;
    const responseData = await apihelper.fetchPostRequest({
      url,
      token,
      payload: JSON.stringify(payload),
      errorMsg: "Failed to sync EWC data.",
    });
    return responseData.status;
  },

  async bookEwcRidesToDispatch(context, { rides }) {
    const token = context.rootGetters.token;
    const url = `${process.env.VUE_APP_ROOT_API}${process.env.VUE_APP_ROOT_API_ENV}/combinatieritten/ewcRides2Dispatch`;

    const responseData = await apihelper.fetchPostRequest({
      url,
      token,
      payload: JSON.stringify({ rides }),
      errorMsg: "Failed to book EWC rides to dispatch.",
    });

    return responseData.status;
  },
};
